export const MockProdDetails = {
  productName: 'RBRVS',
  about: 'The RBRVS DataManager Online is a vital resource for staying current with all Current Procedural Terminology (CPT®) and other Healthcare Common Procedure Coding System (HCPCS) codes. This leading AMA online resource provides an inner perspective of how CPT and HCPCS Level II codes are created, valued, and utilized in the Resource-Based Relative Value Scale (RBRVS) payment system relied on by the Centers for Medicare & Medicaid Services (CMS) and a large majority of other payers/insurers.',
  features: 'The RBRVS DataManager Online boasts an extensive array of features, including over 19,000 CPT and HCPCS Level II code descriptors and 5,500 AMA-exclusive CPT clinical scenarios with detailed descriptions of pre-/intra-/and post-service physician work. It provides proprietary insights into the assignment of RVUs, along with a rationale for many code valuations, enhancing your understanding of the RBRVS system.<br><br>The RBRVS DataManager Online is a powerful resource for payment information including:<br><ul><li>Accurate calculation of geographically-adjusted Medicare Physician payment amounts</li><li>Over 5,500 AMA exclusive CPT clinical scenarios and detailed descriptions of procedures</li><li>More than 10 years of Medicare utilization data for each CPT and HCPCS Level II code and additional details for the most recent year of Medicare data</li><li>ICD-10-CM-to-CPT crosswalk offering the top five related codes</li><li>Direct practice expense (PE) inputs (clinical staff, medical supplies and equipment) included for every CPT and HCPCS Level II code</li><li>AMA/Specialty Society RVS Update Committee (RUC) rationales for work value and PE recommendations to CMS</li></ul>',
  uses: '<p>The AMA licenses this product on an individual, per-unique-user basis. Subscriptions for one to 10 users can be ordered online through AMA Store.</p>' +
  '<p>To access your RBRVS DataManager Online subscription, please follow the instructions below. As the purchaser or administrator of your RBRVS subscription, you may designate secondary administrator privileges to other users. Administrators do not have to be users of the software, therefore not using one of the seat licenses. These designated administrators will have authorization to manage licenses on your behalf.</p>' +
  '<ol><li>Go to <a hreh="ecommerce.ama-assn.org" target="_blank">ecommerce.ama-assn.org</a> and sign in to your account by clicking on the "Sign In" link in the upper right corner of the page. If you do not have an account click "Create an Account" and follow the prompts.</li>' +
  '<li>Once logged in, click on "Manage RBRVS DataManager Users" on the right side of the page. then "Add User" to enter the name, email address and access type for each user.</li></ol>' +
  '<p>Please note that an email notification will be sent immediately to each user you designate. Please notify your users that you are their administrator, as they will need this information if they have issues accessing their subscriptions.</p>' +
  '<p>Renewal subscriptions<br>If you have increased or decreased the number of users in a subscription, administration is required. Follow the administration steps listed above to grant users access to the renewed subscription.</p>' +
  '<p>If you have questions or need assistance, please call the AMA Member Service Center at an at (800)621-8335, Monday-Friday, 8:30 AM – 4:45PM, CT</p>' +
  '<p>We hope you enjoy your RBRVS DataManager Online subscription!</p>',
  addl: 'We are excited to announce the completion of our initiative to build a new, modern database application! Key changes and new features include:<br><ul><li>Modern Progressive Web App (PWA), that can be accessed on any device with a modern web browser, including desktops, laptops, smartphones and tablets. Specific layouts for desktop, mobile and tablet use have been implemented for efficiency. The user interface dynamically adjusts with window size and device screen size.</li><li>Improved basic search design and functionality, including automatically displaying all matching CPT and HCPCS Level II codes after you enter the first three digits.</li><li>Introduction of Advanced Search and PE Search with 20 search categories that can be combined with And/Or search options. Search results are sortable by clicking on table headers.</li><li>Updated "Medicare Claims Data" tab with more detailed ICD-10 data, non-facility utilization data, and additional subtabs for imaging and diagnostic services, including the Professional Component/Technical Component split.</li><li>Introduction of a new "Billed Together Data" tab with how often each CPT and HCPCS Level II code is reported with other codes on the same Medicare claim.</li></ul>',
}

export const MockProducts = [
  {
    itemNumber: "CRBRV",
    name: "RBRVS DataManager",
    productType: "Online",
    description1: "The RBRVS DataManager Online is a vital resource for staying current with all Current Procedural Terminology (CPT®) and other Healthcare Common Procedure Coding System (HCPCS) codes.",
    description2: "",
    description3: "",
    tiers: [
            {
              tierName: "MEMBER",
              tierDetails: [
                {
                  effectiveDate: "2024-10-31",
                  effectiveQuantity: 1,
                  servicePeriodCode: "Y-0001",
                  pricingPeriodCode: "Y-0001",
                  billingCurrency: "US$",
                  name: "",
                  unitPrice: 240.0
                },
                {
                  effectiveDate: "2024-10-31",
                  effectiveQuantity: 2,
                  servicePeriodCode: "Y-0001",
                  pricingPeriodCode: "Y-0001",
                  billingCurrency: "US$",
                  name: "",
                  unitPrice: 175.2
                },
                {
                  effectiveDate: "2024-10-31",
                  effectiveQuantity: 6,
                  servicePeriodCode: "Y-0001",
                  pricingPeriodCode: "Y-0001",
                  billingCurrency: "US$",
                  name: "",
                  unitPrice: 160.8
                },
                {
                  effectiveDate: "2024-10-31",
                  effectiveQuantity: 11,
                  servicePeriodCode: "Y-0001",
                  pricingPeriodCode: "Y-0001",
                  billingCurrency: "US$",
                  name: "",
                  unitPrice: 144.0
                },
                {
                  effectiveDate: "2024-10-31",
                  effectiveQuantity: 51,
                  servicePeriodCode: "Y-0001",
                  pricingPeriodCode: "Y-0001",
                  billingCurrency: "US$",
                  name: "",
                  unitPrice: 87.6
                }
              ]
            },
            {
              tierName: "NONMBR",
              tierDetails: [
                {
                  effectiveDate: "2024-10-31",
                  effectiveQuantity: 1,
                  servicePeriodCode: "Y-0001",
                  pricingPeriodCode: "Y-0001",
                  billingCurrency: "US$",
                  name: "",
                  unitPrice: 320.0
                },
                {
                  effectiveDate: "2024-10-31",
                  effectiveQuantity: 2,
                  servicePeriodCode: "Y-0001",
                  pricingPeriodCode: "Y-0001",
                  billingCurrency: "US$",
                  name: "",
                  unitPrice: 233.6
                },
                {
                  effectiveDate: "2024-10-31",
                  effectiveQuantity: 6,
                  servicePeriodCode: "Y-0001",
                  pricingPeriodCode: "Y-0001",
                  billingCurrency: "US$",
                  name: "",
                  unitPrice: 214.4
                },
                {
                  effectiveDate: "2024-10-31",
                  effectiveQuantity: 11,
                  servicePeriodCode: "Y-0001",
                  pricingPeriodCode: "Y-0001",
                  billingCurrency: "US$",
                  name: "",
                  unitPrice: 192.0
                },
                {
                  effectiveDate: "2024-10-31",
                  effectiveQuantity: 51,
                  servicePeriodCode: "Y-0001",
                  pricingPeriodCode: "Y-0001",
                  billingCurrency: "US$",
                  name: "",
                  unitPrice: 116.8
                }
              ]
            }
          ]  
  }
];

export const MockProductsDetailsForReview = [{
  itemNumber: "CRBRV",
  productName: "RBRVS DataManager",
  term: "1 Year",
  quantity: 0
/*},{
  itemNumber: "ABC",
  productName: "ABC DataManager",
  term: "2 Year",
  quantity: 0  */
}];

export const MockProdOrderTotal = {
  subTotal: 320.00,
  promoDiscount: 5.00,
  tax: 10.00,
  orderTotal: 325.00
}

export const MockProductConfPriceData = [{
  productName: 'RBRVS DataManager',
  price: 320,
  quantity: 1,
  final: 320
}, {
  productName: 'CPT Assistant Online',
  price: 250,
  quantity: 1,
  final: 250 
}];

export const MockUserAddress = {
  name: 'John Smith',
  orgName: 'AMA',
  address1: '330 N Wabash Ave',
  address2: '',
  city: 'Chicago',
  state: 'IL',
  zip: 60611,
}

export const MockPaymentDtls = {
  method: 'card',
  cardType: 'Visa',
  number: '0008',
  month: '04',
  year: '2026'
}

export const MockProduct3 = {
  itemNumber: 'CER',
  name: 'Clinical Examples in Radiology',
  description: 'Clinical Examples in Radiology is now included with a CPT Assistant Online subscription. Learn more or purchase today from InnoviHealth – click "View" below'
}

export const MockProduct2 = {
  itemNumber: 'CPTA',
  name: 'CPT Assistant',
  description: 'Our content has moved to a new platform! Purchase today from InnoviHealth – click "View" below'
}